import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { SuccessAlertI18nMessage, SuccessAlertI18nTitleText } from '../components/i18n/SuccessAlertI18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalErrorAlertI18nMessage, ApprovalErrorAlertI18nTitle } from '../components/i18n/ApprovalErrorAlertI18n';
import { ApprovalRequestAccessSuccessAlert } from '../components/i18n/ApprovalRequestAccessSuccessAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export const getErrorAlertTranslationKeys = errorSubCategory => {
  const defaultTitleTextKey = 'productApprovals.ApprovalErrorAlert.titleText.default';
  const defaultMessageKey = 'productApprovals.ApprovalErrorAlert.message.default';
  const titleTextKey = `productApprovals.ApprovalErrorAlert.titleText.${errorSubCategory}`;
  const messageKey = `productApprovals.ApprovalErrorAlert.message.${errorSubCategory}`;
  return {
    titleText: isValidI18nKey(titleTextKey) ? titleTextKey : defaultTitleTextKey,
    message: isValidI18nKey(messageKey) ? messageKey : defaultMessageKey
  };
};
export const operationSuccessAlert = (approvalType, approvalOperation, assetName) => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(SuccessAlertI18nTitleText, {
      approvalOperation: approvalOperation
    }),
    message: /*#__PURE__*/_jsx(SuccessAlertI18nMessage, {
      approvalOperation: approvalOperation,
      approvalType: approvalType,
      assetName: assetName
    }),
    type: 'success',
    'data-test-id': 'product-approvals-success-alert'
  });
};
export const updateApproversSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.successAlert.message"
    }),
    type: 'success',
    'data-test-id': 'product-approvals-update-success-alert'
  });
};
export const requestedAccessToApprovalsSuccessAlert = approvalType => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(ApprovalRequestAccessSuccessAlert, {
      approvalType: approvalType
    }),
    type: 'success',
    'data-test-id': 'product-approvals-request-access-success-alert'
  });
};
export const dueDateUpdateSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.dueDate.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.dueDate.successAlert.message"
    }),
    type: 'success',
    'data-test-id': 'product-approvals-due-date-update-success-alert'
  });
};
export const approvalTitleUpdateSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalTitle.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalTitle.successAlert.message"
    }),
    type: 'success'
  });
};
export const genericErrorAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalErrorAlert.titleText.default"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalErrorAlert.message.default"
    }),
    type: 'danger'
  });
};
export const reRequestReviewSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.reRequestReview.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.reRequestReview.successAlert.message"
    }),
    type: 'success'
  });
};
export const approveStepSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approveStep.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approveStep.successAlert.message"
    }),
    type: 'success'
  });
};
export const requestAgentToApplyChangesSuccessAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.requestAgentToApplyChanges.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.requestAgentToApplyChanges.successAlert.message"
    }),
    type: 'success'
  });
};
export const sendReminderSuccessAlert = approverName => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.sendReminder.successAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.sendReminder.successAlert.message",
      options: {
        approverName
      }
    }),
    type: 'success'
  });
};
export const sendReminderRateLimitAlert = approverName => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.sendReminder.rateLimitError.title",
      options: {
        approverName
      }
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.sendReminder.rateLimitError.message",
      options: {
        approverName
      }
    }),
    type: 'warning'
  });
};
export const requestAccessErrorAlert = () => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalRequestAccess.errorAlert.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalRequestAccess.errorAlert.message"
    }),
    type: 'danger',
    'data-test-id': 'product-approvals-request-access-error-alert'
  });
};
export const floatingErrorAlert = (approvalType, errorSubCategory) => {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nTitle, {
      approvalType: approvalType,
      errorSubCategory: errorSubCategory
    }),
    message: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nMessage, {
      approvalType: approvalType,
      errorSubCategory: errorSubCategory
    }),
    type: 'danger'
  });
};